// CollectionHero.jsx
import React from 'react';
import styles from './CollectionPage.module.css';

function CollectionHero() {
  return (
    <div className={styles.heroContainer}>
      {/* BADGE */}
      <div className={styles.badge}>Collection Solutions</div>

      {/* HEADLINE */}
      <h1 className={styles.headline}>
        Collect Smarter <br />
        Recover More
      </h1>

      {/* SUBTITLE */}
      <p className={styles.subtitle}>
        Deploy AI voice and messaging agents that transform your collection process. Recover <strong>40% more</strong> while cutting costs by <strong>60%</strong> across debt, medical, B2B, and loan collections. Fully compliant. Always professional.
      </p>

      {/* CTA BUTTONS */}
      <div className={styles.ctaButtons}>
        <button className={styles.primaryBtn}>Schedule a Demo</button>
        <button className={styles.secondaryBtn}>Explore Solutions</button>
      </div>

      {/* STATS SECTION (NEW) */}
      <div className={styles.statsContainer}>
        {/* Stat 1 */}
        <div className={styles.statCard}>
          <h2 className={styles.statNumber}>40%</h2>
          <p className={styles.statLabel}>Higher Recovery</p>
        </div>

        {/* Stat 2 */}
        <div className={styles.statCard}>
          <h2 className={styles.statNumber}>60%</h2>
          <p className={styles.statLabel}>Lower Costs</p>
        </div>

        {/* Stat 3 */}
        <div className={styles.statCard}>
          <h2 className={styles.statNumber}>100%</h2>
          <p className={styles.statLabel}>Compliant</p>
        </div>

        {/* Stat 4 */}
        <div className={styles.statCard}>
          <h2 className={styles.statNumber}>3x</h2>
          <p className={styles.statLabel}>Contact Rate</p>
        </div>
      </div>

      {/* ✅ NEW SECTION: Traditional Collections Are Broken */}
      <section className={styles.traditionalSection}>
        <h2 className={styles.traditionalTitle}>Traditional Collections Are Broken</h2>

        <p className={styles.traditionalText}>
          The average collection agency reaches only <strong>15-20%</strong> of debtors. Agents burn out making hundreds of calls that go unanswered. Compliance violations cost millions in fines.
        </p>

        <p className={styles.traditionalText}>
          Meanwhile, debtors ignore calls from unknown numbers, emails go to spam, and payment opportunities slip away every day.
        </p>

        <p className={styles.solutionText}>
          <strong>ToxBox.ai's AI agents</strong> reach <span className={styles.highlight}>3x more debtors</span>, negotiate payment plans <span className={styles.highlight}>24/7</span>, and guarantee <span className={styles.highlight}>100% compliance</span> — turning your collection operation into a recovery engine.
        </p>

        {/* TRADITIONAL STATS CARDS */}
        <div className={styles.traditionalStatsGrid}>
          {/* Card 1 */}
          <div className={styles.traditionalStatCard}>
            <h3 className={styles.traditionalStatNumber}>15-20%</h3>
            <p className={styles.traditionalStatLabel}>Industry avg contact rate</p>
          </div>

          {/* Card 2 */}
          <div className={styles.traditionalStatCard}>
            <h3 className={styles.traditionalStatNumber}>10-15%</h3>
            <p className={styles.traditionalStatLabel}>Traditional recovery rate</p>
          </div>

          {/* Card 3 */}
          <div className={styles.traditionalStatCard}>
            <h3 className={styles.traditionalStatNumber}>$0.25-0.35</h3>
            <p className={styles.traditionalStatLabel}>Cost per dollar collected</p>
          </div>

          {/* GRADIENT BANNER */}
      <div className={styles.gradientBanner}>
        <h2 className={styles.bannerTitle}>With ToxBox.ai</h2>
        <p className={styles.bannerSubtitle}>60% Contact Rate. 40% More Recovery.</p>
      </div>

        </div>
      </section>

      {/* ✅ NEW SECTION: Collections Across Every Industry */}
<section className={styles.industrySection}>
  <h2 className={styles.industryTitle}>Collections Across Every Industry</h2>
  <p className={styles.industrySubtitle}>
    Purpose-built AI agents for every type of receivable — compliant, professional, and effective.
  </p>

  <div className={styles.industryCardsContainer}>
    {/* Card 1: Debt Collection */}
    <div className={styles.industryCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#E0F0FF' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign-icon lucide-dollar-sign"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
      </div>
      <h3 className={styles.cardTitle}>Debt Collection</h3>
      <p className={styles.cardDescription}>
        Consumer debt, credit cards, and personal loans with FDCPA-compliant outreach.
      </p>
    </div>

    {/* Card 2: Medical Billing */}
    <div className={styles.industryCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#E0F8E8' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-icon lucide-shield"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
      </div>
      <h3 className={styles.cardTitle}>Medical Billing</h3>
      <p className={styles.cardDescription}>
        Patient balances and insurance follow-ups with HIPAA-compliant communications.
      </p>
    </div>

    {/* Card 3: B2B Collections */}
    <div className={styles.industryCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#F0E0FF' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-icon lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><path d="M16 3.128a4 4 0 0 1 0 7.744"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><circle cx="9" cy="7" r="4"/></svg>
      </div>
      <h3 className={styles.cardTitle}>B2B Collections</h3>
      <p className={styles.cardDescription}>
        Commercial receivables and invoice recovery with professional business communication.
      </p>
    </div>

    {/* Card 1: Loan & EMI Recovery */}
    <div className={styles.industryCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#FFF1DC' }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 17l6-6 4 4 8-8"/>
          <path d="M14 3h7v7"/>
        </svg>
      </div>
      <h3 className={styles.cardTitle}>Loan & EMI Recovery</h3>
      <p className={styles.cardDescription}>
        Auto loans, mortgages, and personal loan EMI collections with flexible
        repayment plans and compliant follow-ups.
      </p>
    </div>

    {/* Card 2: Utility Collections */}
    <div className={styles.industryCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#FFF8C6' }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z"/>
        </svg>
      </div>
      <h3 className={styles.cardTitle}>Utility Collections</h3>
      <p className={styles.cardDescription}>
        Electricity, water, telecom, and subscription payment recovery at scale
        with automated reminders and smart escalation.
      </p>
    </div>

   {/* Card 3: Education & Tuition */}
    <div className={styles.industryCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#E4E9FF' }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <path d="M14 2v6h6"/>
        </svg>
      </div>
      <h3 className={styles.cardTitle}>Education & Tuition</h3>
      <p className={styles.cardDescription}>
        Student fee collections and education loan follow-ups with sensitive,
        respectful, and parent-friendly communication.
      </p>
    </div>
  </div>
</section>

{/* ✅ NEW SECTION: Why AI-Powered Collections Win */}
<section className={styles.aiWinSection}>
  <h2 className={styles.aiWinTitle}>Why AI-Powered Collections Win</h2>
  <p className={styles.aiWinSubtitle}>
    Transform your recovery rates while reducing costs and maintaining compliance.
  </p>

  <div className={styles.aiWinCardsContainer}>
    {/* Card 1: Higher Recovery Rates */}
    <div className={styles.aiWinCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#E6F2FF' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up-icon lucide-trending-up"><path d="M16 7h6v6"/><path d="m22 7-8.5 8.5-5-5L2 17"/></svg>
      </div>
      <h3 className={styles.cardTitle}>Higher Recovery Rates</h3>
      <p className={styles.cardDescription}>
        AI-powered strategies increase collection success by 40% with personalized outreach timing and messaging.
      </p>
    </div>

    {/* Card 2: 24/7 Collection Cycles */}
    <div className={styles.aiWinCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#FFF2E6' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-icon lucide-clock"><path d="M12 6v6l4 2"/><circle cx="12" cy="12" r="10"/></svg>
      </div>
      <h3 className={styles.cardTitle}>24/7 Collection Cycles</h3>
      <p className={styles.cardDescription}>
        Never miss a payment window. AI agents reach debtors at optimal times across all time zones.
      </p>
    </div>

    {/* Card 3: 100% Compliance */}
    <div className={styles.aiWinCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#F0F8FF' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-icon lucide-shield"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
      </div>
      <h3 className={styles.cardTitle}>100% Compliance</h3>
      <p className={styles.cardDescription}>
        Built-in FDCPA, TCPA, HIPAA, and state-specific regulations ensure every interaction is compliant.
      </p>
    </div>
    {/* Card 1: Flexible Payment Plans */}
    <div className={styles.benefitCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#E6F2FF' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign-icon lucide-dollar-sign"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
      </div>
      <h3 className={styles.cardTitle}>Flexible Payment Plans</h3>
      <p className={styles.cardDescription}>
        AI negotiates and sets up payment arrangements based on debtor’s ability to pay.
      </p>
    </div>

    {/* Card 2: Preserve Relationships */}
    <div className={styles.benefitCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#FFF2E6' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-icon lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><path d="M16 3.128a4 4 0 0 1 0 7.744"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><circle cx="9" cy="7" r="4"/></svg>
      </div>
      <h3 className={styles.cardTitle}>Preserve Relationships</h3>
      <p className={styles.cardDescription}>
        Empathetic, professional conversations maintain customer goodwill while recovering funds.
      </p>
    </div>

    {/* Card 3: Real-Time Analytics */}
    <div className={styles.benefitCard}>
      <div className={styles.iconWrapper} style={{ backgroundColor: '#F0F8FF' }}>
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-column-decreasing-icon lucide-chart-column-decreasing"><path d="M13 17V9"/><path d="M18 17v-3"/><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M8 17V5"/></svg>
      </div>
      <h3 className={styles.cardTitle}>Real-Time Analytics</h3>
      <p className={styles.cardDescription}>
        Track recovery rates, agent performance, and campaign effectiveness with live dashboards.
      </p>
    </div>

  </div>
</section>

{/* ✅ NEW SECTION: Traditional vs AI-Powered Collections */}
<section className={styles.comparisonSection}>
  <h2 className={styles.comparisonTitle}>Traditional vs AI-Powered Collections</h2>
  <p className={styles.comparisonSubtitle}>The numbers speak for themselves.</p>

  <div className={styles.comparisonTable}>
    {/* Header Row */}
    <div className={styles.tableRow} style={{ fontWeight: '600', borderBottom: '1px solid #e2e8f0' }}>
      <div className={styles.tableCell}>Metric</div>
      <div className={styles.tableCell}>Traditional</div>
      <div className={styles.tableCell} style={{ color: '#7C3AED' }}>ToxBox.ai</div>
    </div>

    {/* Data Rows */}
    <div className={styles.tableRow}>
      <div className={styles.tableCell}>Contact Rate</div>
      <div className={styles.tableCell} style={{ color: '#EF4444' }}>15–20%</div>
      <div className={styles.tableCell} style={{ color: '#10B981' }}>45–60%</div>
    </div>

    <div className={styles.tableRow}>
      <div className={styles.tableCell}>Right-Party Contact</div>
      <div className={styles.tableCell} style={{ color: '#EF4444' }}>8–12%</div>
      <div className={styles.tableCell} style={{ color: '#10B981' }}>25–35%</div>
    </div>

    <div className={styles.tableRow}>
      <div className={styles.tableCell}>Promise-to-Pay Rate</div>
      <div className={styles.tableCell} style={{ color: '#EF4444' }}>5–8%</div>
      <div className={styles.tableCell} style={{ color: '#10B981' }}>15–25%</div>
    </div>

    <div className={styles.tableRow}>
      <div className={styles.tableCell}>Compliance Violations</div>
      <div className={styles.tableCell} style={{ color: '#EF4444' }}>Risk present</div>
      <div className={styles.tableCell} style={{ color: '#10B981' }}>Zero tolerance</div>
    </div>

    <div className={styles.tableRow}>
      <div className={styles.tableCell}>Agent Availability</div>
      <div className={styles.tableCell} style={{ color: '#6B7280' }}>Business hours</div>
      <div className={styles.tableCell} style={{ color: '#10B981' }}>24/7/365</div>
    </div>
  </div>
</section>

{/* ✅ NEW SECTION: AI-Optimized Collection Workflow */}
<section className={styles.workflowSection}>
  <h2 className={styles.workflowTitle}>AI-Optimized Collection Workflow</h2>
  <p className={styles.workflowSubtitle}>
    Intelligent strategies for every stage of delinquency.
  </p>

  {/* STAGE 0: Pre-Due */}
  <div className={styles.workflowStage} style={{ backgroundColor: '#F0FDF4' }}>
    <div className={styles.stageHeader}>
      <div className={styles.circle} style={{ backgroundColor: '#16A34A' }}>0</div>
      <h3 className={styles.stageTitle}>Pre-Due</h3>
      <span className={styles.tag} style={{ backgroundColor: '#D9F6E0', color: '#16A34A' }}>Before Due Date</span>
    </div>
    <div className={styles.featureGrid}>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Upcoming payment reminders
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Due date notifications
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Auto-pay enrollment prompts
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Payment method confirmation
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Early payment incentives
      </div>
    </div>
  </div>

  {/* STAGE 1: Early Stage */}
  <div className={styles.workflowStage} style={{ backgroundColor: '#FEF9C3' }}>
    <div className={styles.stageHeader}>
      <div className={styles.circle} style={{ backgroundColor: '#D97706' }}>1</div>
      <h3 className={styles.stageTitle}>Early Stage</h3>
      <span className={styles.tag} style={{ backgroundColor: '#FEF08A', color: '#D97706' }}>0–30 Days Past Due</span>
    </div>
    <div className={styles.featureGrid}>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Friendly payment reminders
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Auto-pay setup assistance
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Payment date rescheduling
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Balance clarification
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Multiple payment options
      </div>
    </div>
  </div>

  {/* STAGE 2: Mid Stage */}
  <div className={styles.workflowStage} style={{ backgroundColor: '#FFF7ED' }}>
    <div className={styles.stageHeader}>
      <div className={styles.circle} style={{ backgroundColor: '#EA580C' }}>2</div>
      <h3 className={styles.stageTitle}>Mid Stage</h3>
      <span className={styles.tag} style={{ backgroundColor: '#FED7AA', color: '#EA580C' }}>31–90 Days Past Due</span>
    </div>
    <div className={styles.featureGrid}>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Increased outreach frequency
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Payment plan negotiations
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Hardship assessment
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Partial payment acceptance
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Promise-to-pay tracking
      </div>
    </div>
  </div>

  {/* STAGE 3: Late Stage */}
  <div className={styles.workflowStage} style={{ backgroundColor: '#FEF2F2' }}>
    <div className={styles.stageHeader}>
      <div className={styles.circle} style={{ backgroundColor: '#DC2626' }}>3</div>
      <h3 className={styles.stageTitle}>Late Stage</h3>
      <span className={styles.tag} style={{ backgroundColor: '#FECACA', color: '#DC2626' }}>90+ Days Past Due</span>
    </div>
    <div className={styles.featureGrid}>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Settlement offers
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Skip tracing integration
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Legal notice delivery
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Final demand communications
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Agency handoff preparation
      </div>
    </div>
  </div>

  {/* STAGE 4: Recovery */}
  <div className={styles.workflowStage} style={{ backgroundColor: '#EBF5FF' }}>
    <div className={styles.stageHeader}>
      <div className={styles.circle} style={{ backgroundColor: '#2563EB' }}>4</div>
      <h3 className={styles.stageTitle}>Recovery</h3>
      <span className={styles.tag} style={{ backgroundColor: '#BFDBFE', color: '#2563EB' }}>Post-Settlement</span>
    </div>
    <div className={styles.featureGrid}>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Payment confirmation
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Receipt delivery
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Account status updates
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Credit reporting updates
      </div>
      <div className={styles.featureItem}>
        <span className={styles.checkmark}>✓</span> Customer rehabilitation
      </div>
    </div>
  </div>
</section>

{/* ✅ ENTERPRISE COLLECTION PLATFORM SECTION */}
<section className={styles.platformSection}>
  <h2 className={styles.platformTitle}>Enterprise Collection Platform</h2>
  <p className={styles.platformSubtitle}>
    Everything you need to run a modern, compliant collection operation.
  </p>

  <div className={styles.platformCardsGrid}>

    {/* Card 1 */}
    <div className={styles.platformCard}>
      <div className={`${styles.iconWrapper} ${styles.blueBg}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings-icon lucide-settings"><path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"/><circle cx="12" cy="12" r="3"/></svg>
      </div>
      <h3 className={styles.cardTitle}>
        Intelligent call scheduling based on contact patterns
      </h3>
    </div>

    {/* Card 2 */}
    <div className={styles.platformCard}>
      <div className={`${styles.iconWrapper} ${styles.orangeBg}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign-icon lucide-dollar-sign"><line x1="12" x2="12" y1="2" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
      </div>
      <h3 className={styles.cardTitle}>
        Automated payment plan creation and management
      </h3>
    </div>

    {/* Card 3 */}
    <div className={styles.platformCard}>
      <div className={`${styles.iconWrapper} ${styles.lightBlueBg}`}>
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-icon lucide-message-square"><path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/></svg>
      </div>
      <h3 className={styles.cardTitle}>
        Multi-channel outreach (voice, SMS, WhatsApp, email)
      </h3>
    </div>

    {/* Card 4 */}
    <div className={styles.platformCard}>
      <div className={`${styles.iconWrapper} ${styles.lightBlueBg}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-icon lucide-shield"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
      </div>
      <h3 className={styles.cardTitle}>
        Real-time compliance monitoring and recording
      </h3>
      <span className={styles.previewTag}>Preview</span>
    </div>

    {/* Card 5 */}
    <div className={styles.platformCard}>
      <div className={`${styles.iconWrapper} ${styles.orangeBg}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-icon lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><path d="M16 3.128a4 4 0 0 1 0 7.744"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><circle cx="9" cy="7" r="4"/></svg>
      </div>
      <h3 className={styles.cardTitle}>
        Skip tracing and contact verification integration
      </h3>
    </div>

    {/* Card 6 */}
    <div className={styles.platformCard}>
      <div className={`${styles.iconWrapper} ${styles.blueBg}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up-icon lucide-trending-up"><path d="M16 7h6v6"/><path d="m22 7-8.5 8.5-5-5L2 17"/></svg>
      </div>
      <h3 className={styles.cardTitle}>
        Payment gateway integration for instant settlement
      </h3>
    </div>

    {/* Card 7 */}
    <div className={styles.platformCard}>
      <div className={`${styles.iconWrapper} ${styles.lightBlueBg}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-spreadsheet-icon lucide-file-spreadsheet"><path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"/><path d="M14 2v5a1 1 0 0 0 1 1h5"/><path d="M8 13h2"/><path d="M14 13h2"/><path d="M8 17h2"/><path d="M14 17h2"/></svg>
      </div>
      <h3 className={styles.cardTitle}>
        Dispute handling and escalation workflows
      </h3>
    </div>

    {/* Card 8 */}
    <div className={styles.platformCard}>
      <div className={`${styles.iconWrapper} ${styles.orangeBg}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-column-increasing-icon lucide-chart-column-increasing"><path d="M13 17V9"/><path d="M18 17V5"/><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M8 17v-3"/></svg>
       </div>
      <h3 className={styles.cardTitle}>
        Customizable scripts per debt type and age
      </h3>
    </div>

  </div>
</section>



{/* ✅ NEW SECTION: From Setup to Scale in Weeks */}
<section className={styles.setupScaleSection}>
  <h2 className={styles.setupScaleTitle}>From Setup to Scale in Weeks</h2>
  <p className={styles.setupScaleSubtitle}>
    Our team helps you deploy AI agents tailored to your products and processes.
  </p>

  <div className={styles.stepsContainer}>
    {/* Step 1 */}
    <div className={styles.stepCard}>
      <div className={styles.stepNumber}>01</div>
      <h3 className={styles.stepTitle}>Connect & Configure</h3>
      <p className={styles.stepDescription}>
        Integrate with your core banking systems via secure APIs. Define conversation flows and compliance rules.
      </p>
    </div>

    {/* Step 2 */}
    <div className={styles.stepCard}>
      <div className={styles.stepNumber}>02</div>
      <h3 className={styles.stepTitle}>Deploy AI Agents</h3>
      <p className={styles.stepDescription}>
        Launch voice agents for calls and WhatsApp agents for messaging. Each customer gets a personalized journey.
      </p>
    </div>

    {/* Step 3 */}
    <div className={styles.stepCard}>
      <div className={styles.stepNumber}>03</div>
      <h3 className={styles.stepTitle}>Scale & Optimize</h3>
      <p className={styles.stepDescription}>
        Handle millions of interactions while AI continuously learns and improves from every conversation.
      </p>
    </div>
  </div>
</section>

    <section className={styles.section}>
      {/* Header */}
      <div className={styles.header}>
        <h2 className={styles.title}>Voice and Messaging Agents</h2>
        <p className={styles.subtitle}>
          Reach debtors on their preferred channel with professional, compliant communication.
        </p>
      </div>

      {/* Main Cards Row */}
      <div className={styles.cardsRow}>
        {/* Voice Agents Card */}
        <div className={styles.card} style={{ backgroundColor: '#F0F7FF' }}>
          <div className={styles.iconWrapper} style={{ backgroundColor: '#E6F2FF' }}>
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone-icon lucide-phone"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/></svg>
          </div>
          <h3 className={styles.cardTitle}>Voice Agents</h3>
          <p className={styles.cardSubtitle}>Outbound Collection Calls</p>
          <ul className={styles.featureList}>
            <li><span className={styles.checkmark}>✓</span> Natural conversation with empathy</li>
            <li><span className={styles.checkmark}>✓</span> Payment negotiation and plan setup</li>
            <li><span className={styles.checkmark}>✓</span> Real-time payment processing</li>
            <li><span className={styles.checkmark}>✓</span> Dispute handling and escalation</li>
            <li><span className={styles.checkmark}>✓</span> Voicemail and callback scheduling</li>
            <li><span className={styles.checkmark}>✓</span> Multi-language support</li>
          </ul>
        </div>

        {/* Messaging Agents Card */}
        <div className={styles.card} style={{ backgroundColor: '#F0FDF4' }}>
          <div className={styles.iconWrapper} style={{ backgroundColor: '#D9F6E0' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-square-icon lucide-message-square"><path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"/></svg>
          </div>
          <h3 className={styles.cardTitle}>Messaging Agents</h3>
          <p className={styles.cardSubtitle}>SMS & WhatsApp Collection</p>
          <ul className={styles.featureList}>
            <li><span className={styles.checkmark}>✓</span> Conversational two-way messaging</li>
            <li><span className={styles.checkmark}>✓</span> Payment link generation</li>
            <li><span className={styles.checkmark}>✓</span> Document sharing and verification</li>
            <li><span className={styles.checkmark}>✓</span> Automated reminders and follow-ups</li>
            <li><span className={styles.checkmark}>✓</span> Rich media support (images, PDFs)</li>
            <li><span className={styles.checkmark}>✓</span> Preffered channel detection</li>
          </ul>
        </div>
      </div>
    </section>

    {/* COLLECTIONS ACROSS EVERY INDUSTRY */}
<section className={styles.industrySection}>
  <h2 className={styles.industryTitle}>
    Collections Across Every Industry
  </h2>

  <p className={styles.industrySubtitle}>
    Purpose-built AI agents for every type of receivable — compliant,
    professional, and effective.
  </p>

  <div className={styles.industryCardsContainer}>
    {/* Debt Collection */}
    <div className={styles.industryCard}>
      <div
        className={styles.iconWrapper}
        style={{ backgroundColor: "#E0F0FF" }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-icon lucide-shield"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/></svg>
      </div>

      <h3 className={styles.cardTitle}>Debt Collection</h3>
      <p className={styles.cardDescription}>
        Consumer debt, credit cards, and personal loans with FDCPA-compliant
        outreach.
      </p>
    </div>

    {/* Medical Billing */}
    <div className={styles.industryCard}>
      <div
        className={styles.iconWrapper}
        style={{ backgroundColor: "#E0F8E8" }}
      >
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users-icon lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><path d="M16 3.128a4 4 0 0 1 0 7.744"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><circle cx="9" cy="7" r="4"/></svg>
      </div>

      <h3 className={styles.cardTitle}>Medical Billing</h3>
      <p className={styles.cardDescription}>
        Patient balances and insurance follow-ups with HIPAA-compliant
        communications.
      </p>
    </div>

    {/* B2B Collections */}
    <div className={styles.industryCard}>
      <div
        className={styles.iconWrapper}
        style={{ backgroundColor: "#F0E0FF" }}
      >
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up-icon lucide-trending-up"><path d="M16 7h6v6"/><path d="m22 7-8.5 8.5-5-5L2 17"/></svg>
      </div>

      <h3 className={styles.cardTitle}>B2B Collections</h3>
      <p className={styles.cardDescription}>
        Commercial receivables and invoice recovery with professional business
        communication.
      </p>
    </div>
  </div>
</section>

{/* CALL-TO-ACTION SECTION */}
<section className={styles.ctaSection}>
  <h2 className={styles.ctaTitle}>Ready to Transform Your Collections?</h2>
  <p className={styles.ctaSubtitle}>
    Join leading organizations recovering 40% more while cutting costs by 60%
  </p>
  <div className={styles.ctaButtons}>
    <button className={styles.primaryBtn1}>Schedule a Demo</button>
  </div>
  <p className={styles.ctaAdditionalText}>
    Still have Questions? Get in touch with our team
  </p>
</section>


    </div>
  );
}

export default CollectionHero;